<template>
    <div>
        <validation-observer ref="observer" v-slot="{ passes }">
            <span v-if="!updateItem" @dblclick="updateItem = true">
                <strong>{{ item?.keys }}</strong>
                <span class="text-muted ml-2">- {{ item?.description }}</span>
            </span>
            <b-form v-if="updateItem" @submit.prevent="passes(onFormSubmit)" novalidate>
                <div class="d-flex flex-wrap align-items-start">
                    <b-button size="sm" class="mr-2 mb-2" variant="warning" @click="updateItem = false">Undo</b-button>
                    <validation-provider vid="keys" v-slot="{ errors }" class="mr-2 mb-2">
                        <b-form-input
                            size="sm"
                            :state="errors[0] ? false : null"
                            id="keys"
                            name="keys"
                            v-model.trim="form.keys"
                            placeholder="Keys" />
                    </validation-provider>
                    <validation-provider vid="description" v-slot="{ errors }" class="mb-2">
                        <b-form-input
                            size="sm"
                            :state="errors[0] ? false : null"
                            id="description"
                            name="description"
                            v-model.trim="form.description"
                            placeholder="Description" />
                    </validation-provider>
                </div>
                <div class="d-flex flex-wrap align-items-center mt-2">
                    <b-form-checkbox v-model="form.is_public" switch size="sm" class="mr-2 mb-2">Public</b-form-checkbox>
                    <b-button size="sm" type="submit" class="mr-2 mb-2" variant="success">Update</b-button>
                    <b-button size="sm" type="button" class="mb-2" variant="danger" @click="onDelete">Delete</b-button>
                </div>
            </b-form>
        </validation-observer>
    </div>
</template>

<script>
import FormExtension from "@/core/components/FormExtension"
import { mapActions } from "vuex"

export default FormExtension.extend({
    name: 'update-shortcut',
    props: ['item'],
    data() {
        return {
            form: new Form({
                keys: "",
                description: "",
                is_public: false,
                section: "other"
            }),
            updateItem: false
        }
    },
    watch: {
        form: {
            deep: true,
            handler() {
                this.isDirty = this.form.dirty()

                if (this.isDirty) {
                    this.dirty()
                } else {
                    this.validated()
                }
            }
        },
        item: {
            immediate: true,
            handler(val) {
                this.form.withData({
                    ...val,
                    is_public: val?.is_public ?? false,
                    section: val?.section ?? 'other'
                })
            }
        },
    },
    methods: {
        ...mapActions('keyboardshortcuts', ['updateShortcut', 'deleteShortcut']),
        onFormSubmit() {
            this.updateShortcut({
                id: this.item.id,
                data: {
                    keys: this.form.keys,
                    description: this.form.description,
                    section: this.form.section,
                    is_public: this.form.is_public
                }
            }).then(() => {
                this.notify('Shortcut updated', 'Shortcut was updated successfully')
                this.reset()
                this.$emit('updated')
            }).catch(errors => {
                if (errors.response) {
                    this.$refs.observer?.setErrors(errors.response.data)
                    this.hasErrors = true
                }
            })
        },
        onDelete() {
            this.deleteShortcut(this.item?.id).then(() => {
                this.notify('Shortcut deleted', 'Shortcut was deleted successfully')
                this.updateItem = false
                this.validated()
                this.$emit('deleted')
            })
        },
        reset() {
            this.form.reset()
            this.$nextTick(() => {
                this.$refs.observer?.reset()
                this.updateItem = false
                this.hasErrors = false
                this.validated()
            })
        }
    }
})
</script>
